import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-customer-portal.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Customer Engagement";

const CustomerEngagement = () => (
  <div className="bg-gradient-to-b from-gray-100 to-white">
    <HeroSection title={title} className="relative h-full flex-col-reverse sm:flex-row-reverse">
      <HeroSection.Content className="w-full z-[1] sm:text-left md:w-1/2">
        <HeroSection.Header className="md:items-start">
          <Heading tag="h2">{title}</Heading>
        </HeroSection.Header>
        <HeroSection.Description>
          Engage customers and keep them informed throughout the sales and fulfillment process with the Enerflo Customer
          Portal.
        </HeroSection.Description>
        <HeroSection.Action href="/features/customer-engagement" className="btn-navy">
          Keep Your Customers Happy & Informed
        </HeroSection.Action>
      </HeroSection.Content>

      <figure className="flex-grow p-6 w-full xs:w-3/4 md:w-1/2">
        <Image
          src={FigureImage}
          alt="Enerflo Solar Software Platform Customer Engagement Portal."
          layout="responsive"
          quality={100}
          placeholder="blur"
          className="crispImage"
          sizes="(min-width: 768px) 50vw, 100vw"
          lazyBoundary="400px"
        />
      </figure>
    </HeroSection>
  </div>
);

export default CustomerEngagement;
